// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__dPmww","modalImage":"style_modalImage__JLzBR","modalTextUpperClass":"style_modalTextUpperClass__PMqWp"};